var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleChromeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google-chrome",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50.006,
    viewBox: "0 0 50 50.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6097",
    "data-name": "Path 6097",
    d: "M46.517,12.5a25,25,0,0,0-43.306,0l1.5,27Z",
    transform: "translate(0.134)",
    fill: "#e1392c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6098",
    "data-name": "Path 6098",
    d: "M14.176,30.752,3.35,12A25,25,0,0,0,25,49.5l24.5-25Z",
    transform: "translate(0 0.501)",
    fill: "#269846"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6099",
    "data-name": "Path 6099",
    d: "M34.826,30.752,24,49.5A25,25,0,0,0,45.648,12H24Z",
    transform: "translate(1.003 0.501)",
    fill: "#fbc015"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6100",
    "data-name": "Path 6100",
    d: "M24.5,37a12.5,12.5,0,1,0-8.84-3.662A12.5,12.5,0,0,0,24.5,37Z",
    transform: "translate(0.501 0.501)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6101",
    "data-name": "Path 6101",
    d: "M24.4,34.3a9.9,9.9,0,1,0-7-2.9,9.9,9.9,0,0,0,7,2.9Z",
    transform: "translate(0.606 0.606)",
    fill: "#1a73e8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleChromeIcon);
export default __webpack_public_path__ + "static/media/google_chrome_icon.00aa2c5d6c97cf805bf813213d931c30.svg";
export { ForwardRef as ReactComponent };